React = require 'react'
{ UpgradePromptFull } = require 'app/src/components/UpgradePrompts'
{ IconName } = require 'app/common/components/controls'
t = require('app/scripts/views/internal/recup-with-helpers')('board_list')
_ = require 'underscore'
{ trackUe } = require '@trello/analytics'
{ dontUpsell } = require '@trello/config'
{ trackUnsplashViewBySavedUrl } = require 'app/scripts/network/unsplash'
l = require 'app/scripts/lib/localize'

module.exports = class extends React.Component
  displayName: 'BoardListSectionComponent'
  constructor: (props) ->
    super(props)

    @state = {
      collapsed: true
    }

  componentDidMount: ->
    @trackUnsplashViews()

  componentDidUpdate: (prevProps) ->
    if !_.isEqual(@props.items, prevProps.items)
      @trackUnsplashViews()

  trackUnsplashViews: ->
    { items } = @props
    backgrounds = @getDisplayableItems()

    backgroundImages = backgrounds.map((background) ->
      background.props.background.image
    )
    backgroundImagesFiltered = backgroundImages.filter (bg) -> !!bg
    if backgroundImagesFiltered.length
      trackUnsplashViewBySavedUrl backgroundImagesFiltered

  getDisplayableItems: ->
    { items, mayBeSorted } = @props
    { collapsed } = @state
    displayableItems =
      if mayBeSorted
        _.chain items
          .sortBy (item) -> -(item.props.dateLastActivity)
          .filter (item, index) -> !collapsed || index <= 10 ||  !item.props.isLessActive
          .sortBy (item) -> item.props.name.toLowerCase()
          .value()
      else
        items
    return displayableItems

  render: t.renderable ->
    { items,
      header,
      noSidebarMod,
      createNewItem,
      mayBeSorted,
      showAd,
      privateBoardTiles,
      topBanner,
      bottomBanner } = @props
    boardCount = items.length
    displayedItems = @getDisplayableItems()

    lessActiveCount = boardCount - displayedItems.length

    classes = t.classify
      'boards-page-board-section': !showAd
      'mod-no-sidebar': noSidebarMod

    t.div { class: classes }, =>
      if header
        t.addElement header

      if topBanner
        t.div '.boards-page-top-banner', =>
          t.addElement topBanner

      if showAd && !dontUpsell
        t.div '.boards-page-layout', =>
          t.div '.boards-page-layout-sidebar', =>
            t.div '.boards-page-ad-section', =>
              t.addElement @orgAdComponent()
          t.div '.boards-page-layout-list', =>
            t.ul '.boards-page-board-section-list', =>
              for item in displayedItems
                t.addElement item
              if privateBoardTiles
                t.addElement privateBoardTiles
              if createNewItem
                t.addElement createNewItem
      else
        t.ul '.boards-page-board-section-list', ->
          for item in displayedItems
            t.addElement item
          if privateBoardTiles
            t.addElement privateBoardTiles
          if createNewItem
            t.addElement createNewItem

      if bottomBanner
         t.div '.boards-page-bottom-banner', =>
            t.addElement bottomBanner

      onShowAllClick = =>
        @setState(collapsed: false)

      if displayedItems.length < items.length
        t.b onShowAllClick, '.boards-page-show-all-boards.quiet-button',  ->
          t.format 'show-less-active-boards-count', { lessActiveCount }


  orgAdComponent: =>
    React.createElement UpgradePromptFull,
      content: l(['upgrade prompt', 'team page', 'boards', 'content'])
      headline: l(['upgrade prompt', 'team page', 'boards', 'headline'])
      cta: l(['upgrade prompt', 'learn more'])
      ctaLink: @props.billingUrl
      ctaTrackEvent: => trackUe(
        'team page',
        'opens',
        'team page bc tab',
        '',
        '',
        'by clicking full upgrade prompt in team page board tab'
      )
      iconName: IconName.Board
      isDarkTheme: true
